import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
    post: (domain: string) => AxiosInstance.post<any>(`${Config.core.draft}/${domain}`),
}